<script>
    export let exercices;
</script>

<ul>
    {#each exercices as exercice, i}
        <li>
            {i + 1}: {exercice.name}
        </li>
    {/each}
</ul>